/**
 * @readonly
 * @enum {string}
 */
export const TextPosition = {
    LEFT: '-Left',
    RIGHT: '-Right',
    CENTER: '-Center',
    CENTER_LEFT: '-Center-Left',
    CENTER_RIGHT: '-Center-Right',
    BOTTOM: '-Bottom',
    BOTTOM_LEFT: '-Bottom-Left',
    BOTTOM_RIGHT: '-Bottom-Right',
    BOTTOM_CENTER: '-Bottom-Center',
    TOP: '-Top',
    TOP_LEFT: '-Top-Left',
    TOP_RIGHT: '-Top-Right'
};

/**
 * @readonly
 * @enum {string}
 */
export const TextColor = {
    WHITE: '-white',
    BLACK: '-black',
    SALE_RED: '-sale-red'
}